import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import state from './state.js'
import { getField, updateField } from 'vuex-map-fields'
import helper from './helper'
import _filters from './_filters'

const { detect } = require('detect-browser')
const browser = detect()

Vue.use(Vuex)

export default new Vuex.Store({
  state: state,

  getters: {
    getField,
    browser: () => browser,
  },

  actions: {
    toggleFavorite: ({ state }, object) => {
      if (state.favorites.includes(object.id)) {
        Vue.delete(state.favorites, state.favorites.indexOf(object.id))
      } else {
        Vue.set(state.favorites, state.favorites.length, object.id)
      }
      Vue.set(state.searchFilters, 'favorites', 0)
      window.localStorage.setItem('my_favorites', JSON.stringify(state.favorites))
    },

    addBookingExtra: ({ state }, index) => {
      if (!state.bookingExtrasSelected[index]) {
        Vue.set(state.bookingExtrasSelected, index, 0)
      }
      Vue.set(state.bookingExtrasSelected, index, state.bookingExtrasSelected[index] + 1)
    },

    removeBookingExtra: ({ state }, index) => {
      if (!state.bookingExtrasSelected[index]) {
        Vue.set(state.bookingExtrasSelected, index, 0)
      }
      if (state.bookingExtrasSelected[index] > 0) {
        Vue.set(state.bookingExtrasSelected, index, state.bookingExtrasSelected[index] - 1)
      }
    },

    goToFirstPage: ({ state }) => {
      Vue.set(state.searchFilters, 'page', 1)
    },

    getFeatures: ({ state }) => {
      api.getCacheFor('features').then(result => {
        let features = {}
        result.items.forEach(f => {
          features[f._id] = f
        })
        state.featuresList = features
        Object.keys(state.featuresList).forEach(() => {
          // console.log(key, features[key].name_en, features[key].group)
        })
      })
      // api.getListItems('featureGroups', [{ key: 'sortBy', value: 'sortOrder' }])
      api.getCacheFor('featureGroups', 'sortOrder')
        .then(result => {
          state.featureGroups = result.items
      })
      // api.getListItems('objectRoomTypes', [])
      api.getCacheFor('objectRoomTypes').then(result => {
        let types = {}
        result.items.forEach(t => {
          types[t._id] = t
        })
        state.objectRoomTypesById = types
      })
    },

    setVal: ({ commit, }, p) => {
      commit('setVal', p)
    },

    sendBooking: ({ state }, { booking, translations }) => {
      booking.translations = translations
      booking.dateStart = helper.dateToYMD(state.searchFilters.dateStart)
      booking.dateEnd = helper.dateToYMD(state.searchFilters.dateEnd)
      booking.adults = parseInt(booking.adults)
      booking.kids = parseInt(booking.kids)
      booking.infants = parseInt(booking.infants)
      booking.lateCheckInFee = booking.lateCheckInFee
      booking.payMonthly = booking.payMonthly
      booking.extras = state.bookingExtras
      booking.extrasSelected = state.bookingExtrasSelected
      booking.from = booking.dateStart + " " + booking.checkInTime
      booking.to = booking.dateEnd + " " + booking.checkOutTime
      booking.language = state.lang
      booking.guests = "adults: " + booking.adults + ",\n" +
        "kids: " + booking.kids + ",\n" +
        "infants: " + booking.infants
      return api.sendBooking(booking).then(() => {
        state.searchFilters.dateStart = null
        state.searchFilters.dateEnd = null
      })
    },

    sendContact: ({ state }, { contact, translations }) => {
      contact.translations = translations
      contact.dateStart = helper.dateToYMD(state.searchFilters.dateStart)
      contact.dateEnd = helper.dateToYMD(state.searchFilters.dateEnd)
      contact.adults = parseInt(contact.adults)
      contact.kids = parseInt(contact.kids)
      contact.infants = parseInt(contact.infants)
      contact.language = state.lang
      contact.from = contact.dateStart + " " + contact.checkInTime
      contact.to = contact.dateEnd + " " + contact.checkOutTime
      contact.request = contact.notes
      contact.guests = "adults: " + contact.adults + ",\n" +
        "kids: " + contact.kids + ",\n" +
        "infants: " + contact.infants
      return api.sendContact(contact).then(() => {})
    },

    limitMaxPeople: ({ state }) => {
      const totalSelected = state.bookingData.adults + state.bookingData.kids
      // Reset only if count is over max
      if (totalSelected > state.selectedObject.maxPeople) {
        Vue.set(state.bookingData, 'adults', state.bookingDataDefaults.adults)
        Vue.set(state.bookingData, 'kids', state.bookingDataDefaults.kids)
        Vue.set(state.bookingData, 'infants', state.bookingDataDefaults.infants)
        }
    },

    getHotObjects: ({ state, commit }) => {
      let apiFilters = {
        page: 1,
        rowsPerPage: 100,
        is_hot: true,
        sortBy: 'sortOrder'
      }
      return new Promise(resolve => {
        api.getCacheFor('objects').then(result => {
          result.items = result.items.filter(object => object.is_hot)
            .sort((a, b) => (
              parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
            ))
            .map(object => {
              object.objectImages = object.objectImages.sort((a, b) => {
                return (
                  parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
                )
              })
              return object
            })
          resolve(result)
          commit('setVal', {
            k: 'hotImages',
            v: result.items
          })
          state.progressHot = false
        })

        // api.findObjects(
        //   apiFilters
        // ).then(result => {
        //   resolve(result)
        //   commit('setVal', {
        //     k: 'hotImages',
        //     v: result.items
        //   })
        //   state.progressHot = false
        // })
      })
    },

    findObjects: ({ state, commit }) => {
      let apiFilters = _filters.get(state)
      if (state.isHomepage) {
        apiFilters.rowsPerPage = state.rowsPerHomePage
        apiFilters.sortBy = 'sortOrder'
      }
      return new Promise(resolve => {
        api.findObjects(
          apiFilters
        ).then(result => {
          state.filtersHash = _filters.getHash(state)
          result.items = result.items.map(item => {
            item.objectImages = item.objectImages.sort((a, b) => (
              parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
            ))
            return item
          })
          commit('setVal', {
            k: 'searchResult',
            v: result.items
          })
          commit('setVal', {
            k: 'searchTotal',
            v: result.total
          })
          resolve(result.items)
        })
      })
    },
  },

  mutations: {
    updateField,

    setTranslationsByLang: (state, translationsByLang) => {
      state.translationsByLang = translationsByLang
    },

    setVal: (state, p) => {
      Vue.set(state, p.k, p.v)
    },

    toggleBookingConditionsConfirmed: (state) => {
      Vue.set(state.bookingData, 'confirmed', !state.bookingData.confirmed)
    }

  },

})
